export default __webpack_public_path__ + "static/media/half.3b020a2e.svg";